// extracted by mini-css-extract-plugin
module.exports = {"erir":"styles_erir__1j8oS","erir_status":"styles_erir_status__2raaY","erir_btn":"styles_erir_btn__1URh_","erir_text":"styles_erir_text__zVdD-"};